<div class="modal-header">
    <h4 class="modal-title">Really discard unsaved changes?</h4>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="confirm()">Yes</button>
    <button type="button" class="btn btn-danger" (click)="cancel()">No</button>
</div>